import { Box, Typography, TypographyProps } from "@mui/material";
import { tableTextStyles } from "../WorkflowFlatTable";

interface WorkflowTableTextCellProps {
  text: string;
  TypographyProps?: TypographyProps;
}

export default function WorkflowTableTextCell({
  text,
  TypographyProps,
}: WorkflowTableTextCellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "",
        height: "100%",
      }}
    >
      <Typography
        sx={{
          ...tableTextStyles,
          fontWeight: 400,
          letterSpacing: "0.48px",
          width: "100%",
          ...TypographyProps?.sx,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
